import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from "@angular/material"
import { BaseDialogComponent } from "../../../../../base/dialog-base/dialog-base.component"
import { Stringable, StringableValues } from "../../../../../common/stringable.decorator"
import { JSONRpcResponse } from "../../../../../Interfaces/JSONRpcResponse"
import { DialogService, SuiviService } from "../../../../../services"

const KEY = 'suivi-listing'
@Component({
  selector: 'atyl-suivi-listing',
  templateUrl: './suivi-listing.component.html',
  styleUrls: ['./suivi-listing.component.scss']
})
@Stringable({
  path: "views/partials/content/listing/suivi-listing",
  key: KEY,
})
export class SuiviListing extends BaseDialogComponent implements OnInit {

  listSubscription: any[] = [];
  selectedSuivi: any[] = [];
  listSuivi: any[] = [];
  @StringableValues(KEY)
  strings: any
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SuiviListing>,
    private suiviService: SuiviService,
    dialogService: DialogService,
    changeDetectorRef: ChangeDetectorRef,
    private _snackBar: MatSnackBar,
  ) {
    super(dialogRef, dialogService, changeDetectorRef)
  }

  ngOnInit() {
    this.listSubscription.push(this.suiviService.getAllSuvis(this.data.dossier.ID).subscribe((res: JSONRpcResponse) => {
      this.listSuivi = res.result
    }))
  }
  ngOnDestroy() {
    this.listSubscription.forEach(sub => sub.unsubscribe())
  }
  closeDialog(event: any) {
    this.dialogRef.close()
  }
  selectOrRemoveSuivi(suivi: any) {
    if (this.selectedSuivi.indexOf(suivi) > -1) {
      this.selectedSuivi.splice(this.selectedSuivi.indexOf(suivi), 1)
    } else {
      this.selectedSuivi.push(suivi)
    }
  }

  submitSelectedSuiviList(event: any) {
    let ID =0;
    let typeOrigine="formulaire";
    
    if (this.data.formulaire!=undefined && this.data.formulaire
    &&  this.data.formulaire.demandeFormulaire
    ) {
        console.log("formulaire webserviceParams",this.data.formulaire.demandeFormulaire.ID)
         ID = this.data.formulaire.demandeFormulaire.ID
    }
    else {
        if (this.data.courrier!=undefined && this.data.courrier) {
          console.log("courrier webserviceParams",this.data.courrier.ID)
          ID = this.data.courrier.ID;
          typeOrigine="courrier";
        } else {
           if (this.data.document!=undefined && this.data.document) {
                  console.log("document webserviceParams",this.data.document.ID)
                  ID = this.data.document.ID;
                  typeOrigine="document";
                } 
            
            
        }
    }
    let webserviceParams = {
      suivis: this.idFiy(this.selectedSuivi),
      ID: ID,
      options:{
          type: typeOrigine
        
      }
    }
    console.log("webserviceParams",ID,webserviceParams,this.data)
    if (ID>0) {
        this.listSubscription.push(
          this.suiviService.addOrigineToSuivi(webserviceParams.ID, webserviceParams.suivis, webserviceParams.options).subscribe((res: JSONRpcResponse) => {
            if (res.result.success) {
              this.dialogRef.close(true)
              this._snackBar.open(res.result.message, "Fermer", {
                duration: 6000,
              })
            }
          })
        )
    }
  }

  idFiy(suivisList: any[]) {
    return suivisList.map(suivi => suivi.ID)
  }
}
